"use client";

import './tab-item.css';
import { jsx } from 'react/jsx-runtime';
import { validateSurface } from '../../globals.js';
import '../../_virtual/_tslib.js';
import { Text } from '../../typography/text/index.js';
import checkIfMobileDevice from '../../utilities/check-device/index.js';
import calculateRem from '../../utilities/calculate-rem/index.js';
import 'react';
import '../../utilities/use-viewport/index.js';
import styles from './tab-item.module.scss.js';

const TabItem = ({ minWidth = calculateRem('44px'), width, label, selected, uniqueId, orientation = 'horizontal', highlight, href, target, onClick, ariaLabel, setRef, index, behavior, viewport, overflow, onKeyDown, uniformWidth, surface: surfaceProp = 'lightPrimary', size = 'medium', 'data-analyticstrack': analyticsTrack, 'data-track': track, 'data-track-ignore': ignoreTrack, 'data-clickstream': clickStream, 'data-sitecat-level': level, 'data-sitecat-position': dataPosition, 'data-sitecat-datatrack': dataTrack, 'data-sitecat-cta': cta, 'data-testid': testId = 'tab', }) => {
    const surface = validateSurface(surfaceProp);
    const tabStyles = [styles.tab, styles[surface.toLowerCase()]];
    const tabButtonStyles = [
        styles.tabButton,
        styles[surface.toLowerCase()],
        styles[orientation],
    ];
    if (orientation === 'horizontal')
        tabButtonStyles.push(styles[size]);
    if (highlight && !surface.toLowerCase().includes('dark')) {
        tabButtonStyles.push(styles.highlight);
    }
    if (selected)
        tabButtonStyles.push(styles.selected);
    if (orientation === 'vertical') {
        tabStyles.push(styles[`vertical${size}`]);
    }
    if (orientation === 'vertical')
        tabButtonStyles.push(styles.vertical);
    if (uniformWidth) {
        tabButtonStyles.push(styles.uniformWidth);
        tabStyles.push(styles.uniformWidth);
    }
    if (overflow === 'scroll') {
        tabButtonStyles.push(styles.overflowScrollWidth);
    }
    if (viewport)
        tabStyles.push(styles[viewport]);
    const computedStyle = Object.assign({}, (uniformWidth
        ? {}
        : Object.assign({}, (orientation === 'horizontal' && { minWidth, width }))));
    const commonProps = {
        'data-testid': `${testId}-${index}-button`,
        onClick,
        onKeyDown,
        className: tabButtonStyles.join(' '),
        style: computedStyle,
        id: uniqueId,
        'aria-label': ariaLabel,
        'aria-controls': `tabpanel-${uniqueId}`,
        'data-clickstream': clickStream,
        'data-analyticstrack': analyticsTrack,
        'data-track': track,
        'data-track-ignore': ignoreTrack,
        'data-sitecat-datatrack': dataTrack,
        'data-sitecat-position': dataPosition,
        'data-sitecat-level': level,
        'data-sitecat-cta': cta,
    };
    const textBlock = (jsx(Text, { size: size === 'large' ? 'xsmall' : 'large', kind: size === 'large' ? 'title' : 'body', primitive: "span", bold: true, children: label }));
    const content = behavior === 'navigation' ? (jsx("a", Object.assign({ href: href, target: target }, commonProps, { children: textBlock }))) : (jsx("button", Object.assign({ role: "tab", ref: setRef, tabIndex: selected ? 0 : -1, "aria-selected": selected }, commonProps, { children: textBlock })));
    const isMobileDevice = checkIfMobileDevice();
    return (jsx("li", { id: `tab_${uniqueId}`, className: tabStyles.join(' '), role: isMobileDevice ? 'text' : 'presentation', "data-testid": `${testId}-${index}-list-item`, children: content }));
};

export { TabItem as default };
